import React from "react";

export default function UploadIconV2() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.7502 14.624H5.0627C4.5043 14.6234 3.95241 14.5041 3.44365 14.274C2.93489 14.0438 2.4809 13.7081 2.11181 13.2891C1.74272 12.87 1.46698 12.3773 1.30289 11.8436C1.13879 11.3098 1.0901 10.7473 1.16004 10.1933C1.22997 9.63929 1.41695 9.10651 1.70854 8.63029C2.00014 8.15408 2.38969 7.74534 2.85133 7.43119C3.31298 7.11704 3.83616 6.90468 4.38616 6.80819C4.93616 6.7117 5.50039 6.7333 6.0414 6.87155M5.6252 8.99896C5.62529 8.1077 5.83716 7.22922 6.24335 6.43591C6.64954 5.6426 7.23843 4.95716 7.96148 4.43607C8.68454 3.91499 9.52107 3.57318 10.4021 3.43881C11.2832 3.30444 12.1836 3.38135 13.0291 3.66321C13.8746 3.94507 14.6411 4.42381 15.2653 5.05998C15.8895 5.69615 16.3536 6.47154 16.6193 7.32225C16.8851 8.17296 16.9449 9.07465 16.7938 9.95301C16.6427 10.8314 16.2851 11.6613 15.7504 12.3743M8.30122 11.3855L10.6877 8.99894M10.6877 8.99894L13.0742 11.3855M10.6877 8.99894V14.624"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
